import type { Ref } from 'vue';
import type { SaveDraftMode } from '@/components/dialogs/SaveJobDraftDialog.vue';

import { fetchPostJobDraft, fetchPutJobDraft } from '@/helpers/fetchers';

export interface JobBookingSaveDraftOptions {
  draftId: Ref<number | null>;
  draftName: Ref<string>;
  buildContent: () => unknown;
}

export interface JobBookingSaveDraftComposable {
  saveDraft: (name: string, mode?: SaveDraftMode) => Promise<void>;
}

export default function useJobBookingSaveDraft(
  options: JobBookingSaveDraftOptions,
): JobBookingSaveDraftComposable {
  const { draftId, draftName, buildContent } = options;

  async function saveDraft(
    name: string,
    mode: SaveDraftMode = 'new',
  ): Promise<void> {
    const content = buildContent();
    if (mode === 'update' && draftId.value !== null) {
      await fetchPutJobDraft(draftId.value, { name, content });
      draftName.value = name;
      return;
    }
    const created = await fetchPostJobDraft({ name, content });
    draftId.value = created.id;
    draftName.value = name;
  }

  return { saveDraft };
}
